module.exports = __webpack_public_path__ + "loginbgMb.b6549a97d56f69d44cb6.jpg";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/img/loginbgMb.jpg
// module id = ../../../../../src/assets/img/loginbgMb.jpg
// module chunks = styles